import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { fieldCategory } from "../app/schema";

export const GET_FIELD_CATEGORIES = "GET_FIELD_CATEGORIES";
export const GET_FIELD_CATEGORIES_SUCCESS = "GET_FIELD_CATEGORIES_SUCCESS";
export const GET_FIELD_CATEGORIES_ERROR = "GET_FIELD_CATEGORIES_ERROR";

export const GET_FIELD_CATEGORY = "GET_FIELD_CATEGORY";
export const GET_FIELD_CATEGORY_SUCCESS = "GET_FIELD_CATEGORY_SUCCESS";
export const GET_FIELD_CATEGORY_ERROR = "GET_FIELD_CATEGORY_ERROR";

export const PATCH_FIELD_CATEGORY = "PATCH_FIELD_CATEGORY";
export const PATCH_FIELD_CATEGORY_SUCCESS = "PATCH_FIELD_CATEGORY_SUCCESS";
export const PATCH_FIELD_CATEGORY_ERROR = "PATCH_FIELD_CATEGORY_ERROR";

export const DELETE_FIELD_CATEGORY = "DELETE_FIELD_CATEGORY";
export const DELETE_FIELD_CATEGORY_SUCCESS = "DELETE_FIELD_CATEGORY_SUCCESS";
export const DELETE_FIELD_CATEGORY_ERROR = "DELETE_FIELD_CATEGORY_ERROR";

export const SET_IS_REMOVE_FIELD_CATEGORY_MODAL_VISIBLE = "SET_IS_REMOVE_FIELD_CATEGORY_MODAL_VISIBLE";
export const SET_IS_EDIT_FIELD_CATEGORY_MODAL_VISIBLE = "SET_IS_EDIT_FIELD_CATEGORY_MODAL_VISIBLE";

// Requests
const getFieldCategoriesGet = (fetch, apiHost, accessToken, meta) =>
  fetch(
    `${apiHost}/v1/field-categories?limit=${meta.limit}&offset=${meta.currentPage *
      meta.limit}`,
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      method: "GET"
    }
  ).then(response => {
    return validateResponse(response, {});
  });

const getFieldCategoryGet = (fetch, apiHost, accessToken, placeholder) =>
  fetch(`${apiHost}/v1/field-category/${placeholder}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchFieldCategory = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/field-categories/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteFieldCategory = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/field-categories/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions
export function getFieldCategories(meta) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_FIELD_CATEGORIES],
    payload: {
      promise: getFieldCategoriesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        meta
      )
        .then(data => {
          return normalize(data, { fieldCategories: arrayOf(fieldCategory) });
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getFieldCategory(placeholder) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_FIELD_CATEGORY],
    payload: {
      promise: getFieldCategoryGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        placeholder
      )
        .then(data => {
          return normalize(data, fieldCategory);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateFieldCategory(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_FIELD_CATEGORY],
    payload: {
      promise: patchFieldCategory(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, fieldCategory);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeFieldCategory(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_FIELD_CATEGORY],
    payload: {
      promise: deleteFieldCategory(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsRemoveFieldCategoryModalVisible(value) {
  return {
    type: SET_IS_REMOVE_FIELD_CATEGORY_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsEditFieldCategoryModalVisible(value) {
  return {
    type: SET_IS_EDIT_FIELD_CATEGORY_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/fieldCategories/actions.js